import { Button, Modal, Text, Stack, Space } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker } from 'react-router-dom';
import classes from '../../app.module.css';

export const UnsavedChangesGuard = ({ when }: { when: boolean }) => {
  const { t } = useTranslation('common');

  const blocker = useBlocker(when);
  const [showModal, setShowModal] = useState(false);
  const confirmLeave = useRef<() => void>(null);

  // uncomment, if you also want to prevent page refreshes / navigation with the browsers back & forward buttons
  /* useBeforeUnload((e) => {
        if (when) e.preventDefault();
    }); */

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setShowModal(true);
      confirmLeave.current = () => {
        blocker.proceed();
        setShowModal(false);
      };
    }
  }, [blocker]);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDiscard = () => {
    confirmLeave.current?.();
  };

  return (
    <div>
      {showModal && (
        <Modal
          classNames={{ content: classes.modalContentWhite }}
          title={t('entered_data_title')}
          opened={showModal}
          onClose={handleClose}
          radius={'lg'}
        >
          <Stack>
            <Text>{t('entered_data_warning')}</Text>
            <Space h={'var(--mantine-spacing-xs)'} />
            <Button onClick={handleDiscard}>{t('continue')}</Button>
            <Button variant={'outline'} onClick={handleClose}>
              {t('back')}
            </Button>
          </Stack>
        </Modal>
      )}
    </div>
  );
};
